import React from 'react';
import PropTypes from 'prop-types';

import { useIntl } from 'react-intl';

import { useDialogContext } from '../../context/DialogContext';
import { Dialog } from '@xingternal/dialog';

import styles from './NotSavedDialog.css';

const NotSavedDialog = () => {
  const { dialogPreAction, dialogConfirmation, setDialogConfirmation } =
    useDialogContext();

  const intl = useIntl();
  const confirmHandler = () => {
    dialogPreAction?.current && dialogPreAction.current();
    dialogConfirmation?.dialogAction && dialogConfirmation.dialogAction();
  };
  const [show, setShow] = React.useState(false);

  return (
    <Dialog
      show={show}
      className={styles.dialog}
      testId={'CONFIRM_DISCARD_POPUP'}
      isDestructive={true}
      headline={intl.formatMessage({
        id: 'EP_DISCARD_DIALOG_HEADLINE',
        defaultMessage: 'EP_DISCARD_DIALOG_HEADLINE',
      })}
      text={intl.formatMessage({
        id: 'EP_DISCARD_DIALOG_TEXT',
        defaultMessage: 'EP_DISCARD_DIALOG_TEXT',
      })}
      cancelLabel={intl.formatMessage({
        id: 'EP_DISCARD_DIALOG_CANCEL',
        defaultMessage: 'EP_DISCARD_DIALOG_CANCEL',
      })}
      confirmLabel={intl.formatMessage({
        id: 'EP_DISCARD_DIALOG_CONFIRM',
        defaultMessage: 'EP_DISCARD_DIALOG_CONFIRM',
      })}
      onCancel={() => {
        setDialogConfirmation(null);
        setShow(false);
      }}
      onConfirm={() => confirmHandler()}
    />
  );
};

NotSavedDialog.propTypes = {
  intl: PropTypes.any,
};

export default NotSavedDialog;
